import React from "react";
import { Box, MainTitle, PressableOpacity } from "app/components/common";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import i18n from "@microdoing/shared/i18n";
import ArrowLeft from "app/components/Icons/Arrow/ArrowLeft";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";

interface Props {}

const HeaderMbti = ({}: Props) => {
  const navigation = useNavigation();
  const language = useSelector(getLanguage);

  const goBack = () => {
    navigation.goBack();
  };

  return (
    <Box alignItems="center" justifyContent="space-between" flexDirection="row">
      <Box flexDirection="row">
        {!isWebDesktop && (
          <PressableOpacity onPress={goBack}>
            <ArrowLeft
              style={{ marginRight: theme.spacing.s }}
              color={theme.colors["neutral.900"]}
              height={normalize(30)}
              width={normalize(30)}
            />
          </PressableOpacity>
        )}
        <MainTitle color="neutral.900" variant="l8-bold">
          {i18n.t("mbti-title")}
        </MainTitle>
      </Box>
    </Box>
  );
};

export default HeaderMbti;
